import { NgModule } from '@angular/core';

import { LoginComponent } from './login.component';
import { ComponentsModule } from 'src/app/shared/components/components.module';
import { SharedModule } from '@shared/shared.module';
import { LoginPageModule } from '@airtradeit/login-page';

@NgModule({
  imports: [SharedModule, ComponentsModule, LoginPageModule],
  declarations: [LoginComponent],
})
export class LoginModule {}
